import React, { useEffect } from 'react';
import './conteudo-painel-footer.component.scss';
import { Box, Button, Tabs, TextField } from '@mui/material';
import Tab from '@mui/material/Tab';
import { useInput } from '../../hooks/useInput.hook';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import MenuModel, { ItensMenuModel } from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@mui/icons-material/Add';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposMenuComponent from '../campos-menu/campos-menu.component';
import FooterModel, { ItensComIconesModel, MenusModel, RedesSociaisModel } from '../../models/footer.model';
import CamposComIconesComponent from '../campos-com-icones/campos-com-icones.component';
import CamposRedesSociaisComponent from '../campos-redes-sociais/campos-redes-sociais.component';
import CamposMenuFooterComponent from '../campos-menu-footer/campos-menu-footer.component';

import OpenWithIcon from '@mui/icons-material/OpenWith';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ConteudoPainelMenuProps = {
  setVal: (val: FooterModel) => void;
  footer?: FooterModel;
}

function ConteudoPainelFooterComponent(props: ConteudoPainelMenuProps) {

  const [logo, setLogo] = React.useState(props.footer?.logo);
  const { value: breveTexto, bind: bindBreveTexto, setValue: setBreveTexto } = useInput(props.footer?.breve_texto);
  const [itensIcones, setItensIcones] = React.useState<any>(props.footer?.itens_com_icones ? props.footer?.itens_com_icones : []);
  const [itensRedesSociais, setItensRedesSociais] = React.useState<any>(props.footer?.redes_sociais ? props.footer?.redes_sociais : []);
  const [itensMenus, setItensMenus] = React.useState<any>(props.footer?.menus ? props.footer?.menus : []);

  const [corFundo, setCorFundo] = React.useState(props.footer?.cor_de_fundo);
  const [corTexto, setCorTexto] = React.useState(props.footer?.cor_do_texto);
  const [corDosTitulos, setCorDosTitulos] = React.useState(props.footer?.cor_dos_titulos);
  const [corDosMenus, setCorDosMenus] = React.useState(props.footer?.cor_dos_menus);
  const [corDeFundoBarraInferior, setCorDeFundoBarraInferior] = React.useState(props.footer?.cor_de_fundo_barra_inferior);
  const [corDoTextoBarraInferior, setCorDoTextoBarraInferior] = React.useState(props.footer?.cor_do_texto_barra_inferior);
  const [corRedesSociais, setCorRedesSociais] = React.useState(props.footer?.cor_redes_sociais);



  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  useEffect(() => {
    atualizaMenu();
  }, [itensIcones, itensMenus, itensRedesSociais]);

  // useEffect(() => {
  //   atualizaMenu();
  // }, [
  //   breveTexto,
  //   corFundo,
  //   corDeFundoBarraInferior,
  //   corTexto,
  //   corDoTextoBarraInferior,
  //   corDosMenus,
  //   corDosTitulos,
  //   corRedesSociais,
  //   itensIcones,
  //   logo,
  //   itensMenus,
  //   itensRedesSociais
  // ]);

  // Itens com ícones
  const addIcones = () => {
    const items = itensIcones ? [...itensIcones] : [];
    const newItem: ItensComIconesModel = {
      icone: '',
      legenda: '',
      id: 'itens_com_icones-' + (itensIcones ? itensIcones.length : 0)
    };

    items.push(newItem);

    setItensIcones(items);
  };

  const handleOnDragEnd = (result: any) => {

    const items = Array.from(itensIcones);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensIcones(items);
  }

  const handleChageItemIcones = (item: ItensComIconesModel) => {

    const items = [...itensIcones];
    const itemEncontrado: ItensComIconesModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.legenda = item.legenda;
    itemEncontrado.icone = item.icone;
    setItensIcones(items);
  }

  const removerItemIcones = (id?: string) => {
    setItensIcones(
      itensIcones.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim Itens com ícones

  // Redes sociais
  const addRedesSociais = () => {
    const items = [...itensRedesSociais];
    const newItem: RedesSociaisModel = {
      icone: '',
      url: '',
      id: 'redes_sociais-' + itensRedesSociais.length
    };

    items.push(newItem);

    setItensRedesSociais(items);
  };

  const handleOnDragEndRedesSociais = (result: any) => {

    const items = Array.from(itensRedesSociais);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensRedesSociais(items);
  }

  const handleChageItemRedesSociais = (item: RedesSociaisModel) => {

    const items = [...itensRedesSociais];
    const itemEncontrado: RedesSociaisModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.url = item.url;
    itemEncontrado.icone = item.icone;
    setItensRedesSociais(items);
  }

  const removerItemRedesSociais = (id?: string) => {
    setItensRedesSociais(
      itensRedesSociais.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim Redes sociais

  // Menus
  const addMenus = () => {
    const items = [...itensMenus];
    const newItem: MenusModel = {
      id: 'menu_footer-' + itensMenus.length,
      titulo_do_menu: '',
      item_menu: []
    };

    items.push(newItem);

    setItensMenus(items);
  };

  const handleOnDragEndMenus = (result: any) => {

    const items = Array.from(itensMenus);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensMenus(items);
  }

  const handleChageItemMenus = (item: MenusModel) => {

    const items = [...itensMenus];
    const itemEncontrado: MenusModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.titulo_do_menu = item.titulo_do_menu;
    itemEncontrado.item_menu = item.item_menu;
    setItensMenus(items);
  }

  const removerItemMenu = (id?: string) => {
    setItensMenus(
      itensMenus.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim menus

  const atualizaMenu = () => {
    props.setVal({
      breve_texto: breveTexto ? breveTexto : '',
      cor_de_fundo: corFundo ? corFundo : '',
      cor_de_fundo_barra_inferior: corDeFundoBarraInferior ? corDeFundoBarraInferior : '',
      cor_do_texto: corTexto ? corTexto : '',
      cor_do_texto_barra_inferior: corDoTextoBarraInferior ? corDoTextoBarraInferior : '',
      cor_dos_menus: corDosMenus ? corDosMenus : '',
      cor_dos_titulos: corDosTitulos ? corDosTitulos : '',
      cor_redes_sociais: corRedesSociais ? corRedesSociais : '',
      itens_com_icones: itensIcones,
      logo: logo ? logo : { id: '', src: '' },
      menus: itensMenus,
      redes_sociais: itensRedesSociais,
    });
  }

  return (
    <section className="conteudo-painel-footer">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTabs}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <h2>Footer</h2>
          <div className="logos">
            <AttachmentModalComponent setVal={(attachFile) => setLogo(attachFile)} file={logo} legenda='Logo' />
          </div>
          <TextField rows={3} multiline {...bindBreveTexto} label="Breve texto" className='w50' />

          <h2>Itens com ícones</h2>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="itens-icones">
              {(provided) => (
                <div className="itens-icones" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensIcones?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided, snapshot) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <Typography component="span"><OpenWithIcon /> {item.icone}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposComIconesComponent
                                index={iMenu}
                                itemIcones={item}
                                setVal={(val) => handleChageItemIcones(val)}
                                removeItem={(id) => removerItemIcones(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addIcones}><AddIcon />Adicionar ícone</Button>
          </div>

          <h2>Redes sociais</h2>
          <DragDropContext onDragEnd={handleOnDragEndRedesSociais}>
            <Droppable droppableId="itens-redes-sociais">
              {(provided) => (
                <div className="itens-redes-sociais" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensRedesSociais?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <Typography component="span"><OpenWithIcon /> {item.icone}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposRedesSociaisComponent
                                index={iMenu}
                                itemRedesSociais={item}
                                setVal={(val) => handleChageItemRedesSociais(val)}
                                removeItem={(id) => removerItemRedesSociais(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addRedesSociais}><AddIcon />Adicionar rede social</Button>
          </div>

          <h2>Bloco de menu</h2>
          <DragDropContext onDragEnd={handleOnDragEndMenus}>
            <Droppable droppableId="itens-menus">
              {(provided) => (
                <div className="itens-menus" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensMenus?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <Typography component="span"><OpenWithIcon /> {item.titulo_do_menu}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposMenuFooterComponent
                                index={iMenu}
                                menusFooter={item}
                                setVal={(val) => handleChageItemMenus(val)}
                                removeItem={(id) => removerItemMenu(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addMenus}><AddIcon />Adicionar menu</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <h2>Estilo do footer</h2>
          <label className='w50'>
            <span>Cor do fundo:</span>
            <input type='color' value={corFundo} onChange={(val) => setCorFundo(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corTexto} onChange={(val) => setCorTexto(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor dos títulos:</span>
            <input type='color' value={corDosTitulos} onChange={(val) => setCorDosTitulos(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor dos menus:</span>
            <input type='color' value={corDosMenus} onChange={(val) => setCorDosMenus(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor de fundo barra inferior:</span>
            <input type='color' value={corDeFundoBarraInferior} onChange={(val) => setCorDeFundoBarraInferior(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto barra inferior:</span>
            <input type='color' value={corDoTextoBarraInferior} onChange={(val) => setCorDoTextoBarraInferior(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor redes sociais:</span>
            <input type='color' value={corRedesSociais} onChange={(val) => setCorRedesSociais(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
      </Box>
    </section>
  );
}

export default ConteudoPainelFooterComponent;
